module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"form__filter collapsed\">\n	<i on-click=\"onFilterToggleClick\" class=\"toggle icon-filter2\"></i>\n	<div class=\"table\">\n		<div>\n			<div class=\"title\">\n				ID\n			</div>\n			<div>\n				<control type=\"text\" target=\"filter.id\"/>\n			</div>\n\n			<div class=\"title\">\n				Логин\n			</div>\n			<div>\n				<control type=\"text\" target=\"filter.login\"/>\n			</div>\n\n			<div class=\"title\">\n				Имя\n			</div>\n			<div>\n				<control type=\"text\" target=\"filter.name\"/>\n			</div>\n\n			<div class=\"title\">\n				Роль\n			</div>\n			<div>\n				<control type=\"data-autocomplete\" bind=\"filter.roleid:id\" source=\"Security.Data.Roles\" column=\"name\" strict=\"strict\" />\n			</div>\n\n			<div>\n				<button on-click=\"onFilterClick\">Фильтровать</button>\n			</div>\n		</div>\n	</div>\n</div>")
  }
  return __output.join("");

}